import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import moment from 'moment';

export const LeadStagesCard = ({ item }) => {
  return (
    <div className="m-2 ">
      <Card className="assignedcard">
        <CardActionArea
          sx={{
            //   height: '100%',
            '&[data-active]': {
              backgroundColor: 'action.selected',
              '&:hover': {
                backgroundColor: 'action.selectedHover',
              },
            },
          }}
        >
          <CardContent sx={{ height: '100%' }}>
            <Typography variant="h5" component="div">
              Lead Name :{item ? (item.LeadId ? item.LeadId.name : null) : null}
            </Typography>
            <Typography variant="body2" color="text.secondary" className="d-flex flex-wrap">
              <div className="w-100">Date Stage Changed :{item.date}</div>
              <div className="w-100 my-2">
                {' '}
                Sales (User):{item ? (item.sales ? item.sales.name : null) : null}
              </div>
              <div className="w-100">
                Stage: {item ? (item.stage ? item.stage.name : null) : null}
              </div>
              <div className="w-100">
                Selected Date in this Stage:{' '}
                {item ? moment(item.dateselectedforstage).format('DD/MM/YYYY h:mm A') : null}
              </div>
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
  );
};
